
import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface BackButtonProps {
  borderClass?: string;
  className?: string;
  tooltip?: string;
}

const BackButton = React.forwardRef<HTMLButtonElement, BackButtonProps>(
  ({ borderClass, className, tooltip = "Go back", ...props }, ref) => {
    const navigate = useNavigate();
    
    return (
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <Button
            ref={ref}
            variant="ghost"
            size="icon"
            onClick={() => navigate(-1)}
            className={cn(
              "h-10 w-10 rounded-md border",
              borderClass,
              className
            )}
            aria-label={tooltip}
            {...props}
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    );
  }
);

BackButton.displayName = "BackButton";

export { BackButton };
export type { BackButtonProps };
